import type { InputHTMLAttributes } from 'react';

import { cnm } from 'utils/classNames';

export function isLabelFloating(
	value: InputHTMLAttributes<HTMLInputElement>['value'],
	defaultValue: InputHTMLAttributes<HTMLInputElement>['defaultValue'],
) {
	return Boolean(value || value === 0 || defaultValue || defaultValue === 0);
}

export function getInputClassName({
	disabled,
	extra,
	invalid,
	valid,
}: {
	disabled?: boolean;
	extra?: string;
	invalid?: boolean;
	valid?: boolean;
} = {}): string | undefined {
	return cnm(
		'peer',
		'w-full rounded-xs border px-4 align-middle',
		// Prevent iOS from zooming on focus by having the text at 16px+.
		'text-[1rem]',

		'bg-base text-base',
		disabled && 'bg-disabled',

		// Border color
		'border-strong',
		!disabled && [
			'hover:border-focus hover:outline-1 hover:outline-focus hover:outline-solid',
			valid && 'border-success! outline-success!',
			invalid && 'border-error! outline-error!',
		],

		extra,
	);
}

export type RadioCheckboxColor = 'green';

export function getCheckboxRadioClassName({
	color = 'green',
	disabled,
	extra,
}: {
	color?: RadioCheckboxColor;
	disabled: boolean | undefined;
	extra?: string;
}): string | undefined {
	return cnm(
		'size-6 shrink-0 md:mt-0.25 md:size-5',
		// Disable pointer events to stop the controls from showing mouse feedback,
		// since it's only ARIA disabled.
		disabled && 'pointer-events-none accent-disabled opacity-50',
		!disabled && [
			color === 'green' &&
				'accent-success not-checked:hover:bg-baseHover checked:hover:accent-successHover',
		],
		extra,
	);
}
